"use client"

import { useBreeds } from "@/modules/Pet/hooks/use-breeds"
import { Navbar } from "@/shared/components/Navbar"
import { ROUTE_PREFIXES } from "@/shared/routing/routes"
import { Skeleton } from "@dalmatech/ui"
import { AnimatePresence } from "framer-motion"
import { usePathname } from "next/navigation"
import { type PropsWithChildren } from "react"

import { WelcomeNavbar } from "../components/Navbar/welcome-navbar"
import PageTransition from "../components/PageTransition/page-transition"
import { useMounted } from "../hooks/use-mounted"
import * as styles from "./quote-layout.styled"

type QuoteLayoutProps = PropsWithChildren

export const QuoteLayout = ({ children }: QuoteLayoutProps) => {
  const isMounted = useMounted()
  const pathname = usePathname()
  const isWelcomePage = pathname.startsWith(ROUTE_PREFIXES.welcome)
  const PageTransitionComponent = PageTransition

  // prefetch breeds
  useBreeds()

  return (
    <>
      {isWelcomePage ? <WelcomeNavbar /> : <Navbar />}
      <div className={styles.root}>
        <AnimatePresence initial={false} mode="wait">
          <PageTransitionComponent key={pathname} name={pathname}>
            {isWelcomePage ? null : isMounted ? null : (
              <Skeleton className={styles.breadcrumbSkeleton} />
            )}
            {children}
          </PageTransitionComponent>
        </AnimatePresence>
      </div>
    </>
  )
}
